import { AuthProvider } from "@refinedev/core";
import { SupabaseClient } from "@supabase/supabase-js";

interface LoginParams {
  email: string;
  password: string;
}

interface RegisterParams {
  email: string;
  password: string;
}

const authProvider = (supabase: SupabaseClient): AuthProvider => {
  return {
    login: async ({ email, password }: LoginParams) => {
      const response = await fetch("https://lgkscyytncpeqsypxury.supabase.co/functions/v1/login", {
        method: "POST",
        body: JSON.stringify({
          email,
          password,
          app: "admin",
        }),
      });

      const data = await response.json();

      const { access_token, refresh_token } = data.session;

      await supabase.auth.setSession({
        access_token,
        refresh_token,
      });

      return {
        success: true,
        redirectTo: "/",
      };
    },
    logout: async () => {
      const { error } = await supabase.auth.signOut();
      if (error) {
        return {
          success: false,
          error: {
            name: "Logout Error",
            message: error.message,
          },
        };
      }
      return {
        success: true,
        redirectTo: "/login",
      };
    },
    register: async ({ email, password }: RegisterParams) => {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
      });
      if (error) {
        return {
          success: false,
          error: {
            name: "Registration Error",
            message: error.message,
          },
        };
      }
      return {
        success: true,
        redirectTo: "/",
      };
    },
    check: async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      if (!session) {
        return {
          authenticated: false,
          redirectTo: "/login",
        };
      }
      return {
        authenticated: true,
      };
    },
    getPermissions: async () => {
      return {
        success: true,
        data: [],
      };
    },
    getIdentity: async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (user) {
        return {
          success: true,
          data: {
            id: user.id,
            email: user.email || "",
            name: user.user_metadata?.full_name || user.email || "User",
          },
        };
      }
      return {
        success: false,
        error: {
          name: "Identity Error",
          message: "Failed to get user identity",
        },
      };
    },
    onError: async (error) => {
      if (error.status === 401 || error.statusCode === 401) {
        return {
          logout: true,
          redirectTo: "/login",
        };
      }
      return {};
    },
  };
};

export default authProvider;
